import React, { forwardRef, InputHTMLAttributes } from "react";

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

export const CheckboxItem = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, checked, onChange, className = "", ...props }, ref) => {
    return (
      <label
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
        }}
      >
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          {...props}
          className={className}
        />
        {label && <span>{label}</span>}
      </label>
    );
  }
);

CheckboxItem.displayName = "CheckboxItem";
